<template>
    <div class="o-land-transport-schedule">
        <div
            v-for="platform in prepareData"
            :key="platform.id"
            class="schedule-platform"
        >
            <span
                v-if="platform.number"
                class="schedule-platform-title"
            >
                Plattform {{ platform.number }}
            </span>
            <div class="schedule-platform-container">
                <div
                    v-for="transport in platform.trains"
                    :key="transport.id"
                    class="schedule-platform-row"
                >
                    <div class="schedule-platform-route">
                        <div
                            class="schedule-platform-route-number"
                        >
                            {{ transport.route }}
                        </div>
                        <div
                            class="schedule-platform-route-destination"
                        >
                            {{ transport.destination }}
                        </div>
                    </div>
                    <div class="schedule-platform-time">
                        <div class="schedule-platform-time-nearest">
                            {{ transport.nearest }}
                        </div>
                        <div class="schedule-platform-time-slots">
                            <span
                                class="schedule-platform-time-slot"
                                v-for="time in transport.times"
                                :key="time.id"
                            >
                                {{ time.slot }}
                            </span>
                        </div>
                    </div>
                    <template v-if="transport.isWarnings">
                        <div
                            class="schedule-platform-warning"
                            v-for="(warning, index) in transport.warnings"
                            :key="index"
                        >
                            <div class="schedule-platform-warning-symbol" />
                            <span class="schedule-platform-warning-message">
                                {{ warning }}
                            </span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sortBy } from "lodash";
import { getNewId } from "@/utils/services/core-service";

export default {
    name: 'OLandTransportSchedule',
    props: {
        schedule: {
            type: Array,
            required: true
        }
    },
    computed: {
        prepareData() {
            return sortBy(this.schedule,['number']).reduce((acc, el) => {
                const trains = el.trains.map(element => {
                    const startIndex = element.convertedTimeSlots ? 1 : 0;
                    const times = element.times.slice(startIndex, 5).map(slot => {
                        return {
                            slot: element.convertedTimeSlots ? slot : this.$moment(slot).format("H:mm"),
                            id: getNewId()
                        }
                    })

                    const isWarnings = Boolean(element?.warnings?.length);
                    const nearest = element.times[0] && !element.convertedTimeSlots
                        ? this.formatNearestTime(element.times[0])
                        : element.times[0];

                    return {
                        ...element,
                        nearest,
                        isWarnings,
                        times
                    }
                });
                const item = {
                    ...el,
                    id: getNewId(),
                    trains
                }

                acc.push(item)
                return acc;
            }, []);
        }
    },
    methods: {
        formatNearestTime(time){
            const t = this.$moment(time);
            return (t > this.$moment().add(1,'hour') || t < this.$moment()) ? t.format('H:mm')
                : Math.round( this.$moment.duration( t.diff(this.$moment()) ).asMinutes() ) + ' min';
        },
    }
}
</script>

<style lang="scss" src="./theme.scss" />
